import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../store";
import { getSearchParams, fetchGet } from "../../common/common";
import { getSearchTourPackageResults, updateAccoTypeData,updateShowpassenger,updateSeatChart } from "../../actions/search-actions";
import { apiUrl } from "../common/constants";
import HeaderNew from "../header/HeaderNew";
import Footer from "../header/footer";
import Modify from "../modify/modify";
import PackageList from "./PackageList";
import Alert from "../common/alert";

let srchPrm = "";

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            prevLink: "",
            nextLink: "",
            holdFlag: '',
            alert : { show: false, msg: '' }
        };
    }

    componentWillMount() {
        srchPrm = getSearchParams();
    }

    componentDidMount() {

        const that = this;

        //for reset show passenger values
        let showPassenger = that.props.search.showPassenger;
        for (let key in showPassenger) {
            showPassenger[key] = false;
        }
        store.dispatch(updateShowpassenger(showPassenger))

        //for reset show charts values
        let stChrtStatus = that.props.search.stChrtStatus;
        for (let key in stChrtStatus) {
            store.dispatch(updateSeatChart(key, false));
        } 

        that.setState({ showLoader: true });
        let url = window.url + apiUrl.getBusID + "?VariantCode=" + srchPrm.variantCode + "&Date=" + srchPrm.jDate + "&TripRouteID=" + srchPrm.tripRoute;

        fetchGet(url)
            .then(function (response) {
                const busRes = JSON.parse(response);
                //console.log("busRes", busRes);
                if (busRes?.Success) {
                    const tourPackageList = busRes?.data?.filter((obj)=>obj.CityTownIDFrom === Number(srchPrm.fromCity));
                    store.dispatch(getSearchTourPackageResults(tourPackageList));
                } else {
                    store.dispatch(getSearchTourPackageResults(false));
                }

                that.setState({ showLoader: false });
            })
            .catch(function (error) {
                store.dispatch(getSearchTourPackageResults(false));
                that.setState({ showLoader: false });
                console.log(error);
            });

        //for get accommodation	type data
        this.getAccoType();
    }


    getAccoType = () => {

        const that = this;

        that.setState({ showLoader: true });
        //let url = window.url + apiUrl.getAccoType;
        let url = window.cdnUrl + apiUrl.getAccoType;

        fetchGet(url)
            .then(function (response) {
                const accTypeRes = JSON.parse(response);

                if (accTypeRes?.Success) {
                    const accoTypeList = accTypeRes?.data;
                    store.dispatch(updateAccoTypeData(accoTypeList));
                } else {
                    store.dispatch(updateAccoTypeData(false));
                }

                that.setState({ showLoader: false });
            })
            .catch(function (error) {
                store.dispatch(updateAccoTypeData(false));
                that.setState({ showLoader: false });
                console.log(error);
            });
    }

    handleAlert = (msg = false) => {
        if (msg) {
            this.setState({alert : { show: true, msg }});
        } else {
            this.setState({alert : { show: false, msg: '' }})
        }
    }

    render() {

        //console.log(this.props.search);

        let that = this;

        return (
            <div>
                <HeaderNew />
                {that.state.showLoader || that.props.search.loader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                    <div className="result-container">
                        <Modify />
                        <div className="filter--and--card--wrap">
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <PackageList showAlert={(msg) => this.handleAlert(msg)}/>
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
                {
                    that.state.alert.show && <Alert msg={that.state.alert.msg} error={true} close={() => this.handleAlert()} />
                }
            </div>
        )
    }
}


const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(Index);